<template>
  <div>
  <v-row>
    <v-col cols="6" class="pt-0 pb-0">
      <v-text-field class="input-text-size ma-0 pa-0 mt-4"
      v-model="editedItem.systemId" label="System ID" readonly tabindex="-1"/>
      <v-text-field class="input-text-size ma-0 pa-0 mt-n2"
      v-model="editedItem.mainPropertyOrParcelId" label="Property ID" readonly tabindex="-1"/>
      <v-text-field class="input-text-size ma-0 pa-0 mt-n2"
      v-model="editedItem.mainTaxYear" label="Base Tax Year" readonly tabindex="-1"/>
      <v-text-field class="input-text-size ma-0 pa-0 mt-n2"
      v-model="editedItem.mainTaxId" label="Tax ID" readonly tabindex="-1"/>
      <v-text-field class="input-text-size ma-0 pa-0 mt-n2"
      v-model="editedItem.mainCurrentOwnerName" label="Current Owner Name"
      v-uppercase="isEverythingToCaps"/>
      <v-text-field class="input-text-size ma-0 pa-0 mt-n2"
      :value="amountFormat(editedItem.mainAssessedValue)" label="Assessed Value" readonly tabindex="-1"/>
      <ClarionDateControl class="input-text-size ma-0 pa-0 mt-n6" :isToggle="false"
      v-model="editedItem.saleDate" label="Sale Date" :isDisabled="true"/>
      <ClarionDateControl class="input-text-size ma-0 pa-0 mt-n6" :isToggle="false"
      v-model="editedItem.advertisedDate" label="Advertised Date" :isDisabled="true"/>
    </v-col>
    <v-col cols="6" class="pt-0 pb-0">
      <v-text-field class="input-text-size ma-0 pa-0 mt-4"
      :value="amountFormat(editedItem.mainTotalTaxDue)" label="Total Tax Due" readonly tabindex="-1"/>
      <v-text-field class="input-text-size ma-0 pa-0 mt-n2"
      :value="amountFormat(editedItem.mainTotalFeesDue)" label="Total Fees Due" readonly tabindex="-1"/>
      <v-text-field class="input-text-size ma-0 pa-0 mt-n2"
      :value="amountFormat(editedItem.mainTotalPenalty)" label="Current Penalty" readonly tabindex="-1"/>
      <v-text-field class="input-text-size ma-0 pa-0 mt-n2"
      :value="amountFormat(editedItem.mainTotalDue)" label="Total Due" readonly tabindex="-1"/>
      <v-text-field class="input-text-size ma-0 pa-0 mt-n2"
      :value="amountFormat(editedItem.mainTwoThirdsAssessed)"
      label="2/3 Assessed + Costs" readonly tabindex="-1"/>
    </v-col>
  </v-row>
  <v-textarea class="input-text-size pt-0 pb-0 mb-n5" v-model="editedItem.mainLegalDesc"
    outlined rows="1" label="Legal Description" v-textAreaUppercase="isEverythingToCaps" />
  <v-row class="mt-n10">
    <v-col>
      <v-btn class="input-text-size" text color="blue darken-1"
        @click="additionalNameAddressClick">Additional Name/Addresses</v-btn>
    </v-col>
    <v-col class="text-right">
      <v-btn class="input-text-size" text color="blue darken-1"
        @click="pullCurrentDetailsClick">Pull current details</v-btn>
      <v-btn class="input-text-size" text color="blue darken-1"
        @click="addDetailClick">Add detail</v-btn>
    </v-col>
  </v-row>
  <ResalePropertDetailsList :canDelete="true" @deleteRowItem="deleteRowItem"
    :baseCrudKey="baseCrudKeyForResaleDetails" :ResalePropertyBaseCrudKey="baseCrudKey"
    :enableSingleClick="false" :disableKeyboardFunc="false" :enableTotals="false"
    wrapperCss="mt-3" @handleRowButtonClick="handleRowButtonClick"/>

  <CRUDDialog :baseCrudKey="baseCrudKeyAdditionalDialog" :canSave="false"
  dialogDynamicWidth="60vw">
    <template v-slot:[`editedItem`]="{}">
      <AdditionalNameAddressesList :baseCrudKey="baseCrudKeyAdditional"
       :baseCrudKeyAdditionalTable="baseCrudKeyAdditionalTable"
       @upsertTransaction="upsertTransaction" @deleteRecord="deleteRecord" />
    </template>
  </CRUDDialog>
  <CRUDDialog ref="crudDialogForAddDetail" :baseCrudKey="baseCrudKeyForAddDetail"
    dialogDynamicWidth="30vw" :canSave="false" :canCancel="false"
    onlyDialogHeaderName="Add Record to Resale Details">
    <template v-slot:[`editedItem`]="{ }">
      <v-text-field class="input-text-size" label="Tax Year"
        v-model.number="addDetail.taxYear" type="number" :rules="rules"/>
      <v-text-field class="input-text-size" label="Tax ID" v-model.number="addDetail.taxId"
        type="number" :rules="rules" />
    </template>
    <template v-slot:[`additionalActionsAfterSave`]="{}">
      <v-btn class="input-text-size" text
        color="blue darken-1" @click="handleAddNewRecord()">
        OK
      </v-btn>
      <v-btn class="input-text-size" text
        color="blue darken-1" @click="closeAddDetailDialog()">
        Cancel
      </v-btn>
    </template>
  </CRUDDialog>
  <CRUDDialog
    :baseCrudKey="resaleFeesDialogCrudKey"
    :canSave="false"
    :canApply="false"
    :canCancel="true"
    dialogDynamicWidth="30vw"
    :onlyDialogHeaderName="`Fees for Tax Year ${feesRowContext.taxYear || ''} / Tax ID ${feesRowContext.taxId || ''}`">
    <template v-slot:[`editedItem`]="{}">
      <CRUDList
        ref="resaleFeesCrudList"
        :canAdd="true" :canEdit="true" :canDelete="true" :canSave="true"
        :showSelect="false" :displayTopPagination="false" :hideDefaultFooter="true"
        :enableFixedHeaders="true" :headers="feesHeaders"
        :baseCrudKey="resaleFeesListCrudKey"
        :defaultSortBy="feesDefaultSortBy"
        :createNewItem="createNewFeeItem"
        tableWrapperDynamicClassname="taxroll-table-wrapper-two"
        tableDynamicHeight="200"
        dialogDynamicWidth="23vw"
        dialogHeaderName="Fee"
        @upsertItem="upsertResaleFee"
        @emitDeleteRowItem="deleteResaleFee">
        <template v-slot:[`editedItem`]="{}">
          <TaxFeesTableDialog :baseCrudKey="resaleFeesListCrudKey" />
        </template>
      </CRUDList>
    </template>
  </CRUDDialog>
  </div>
</template>

<script>
import {
  mapActions,
  mapGetters,
  mapMutations,
  mapState,
} from 'vuex';
import ClarionDateControl from '../../../../../common/ClarionDateControl.vue';
import { amountFormat, amountToNumber, zipDeFormat } from '../../../../../../util/shared/vue-global';
import ResalePropertDetailsList from '../ResalePropertDetailsList.vue';
import AdditionalNameAddressesList from './AdditionalNameAddressesList.vue';
import CRUDDialog from '../../../../../common/base/crud-2.0/CRUDDialog.vue';
import CRUDList from '../../../../../common/base/crud-2.0/CRUDList.vue';
import { toIsoDate, toShortDate } from '../../../../../../util/shared/tmc-global';
import TaxFeesTableDialog from '../../../../TaxInquiry/Common/TaxFeesTableDialog.vue';
import { FeesHeaders } from '../../../../TaxInquiry/TaxInquiryUtils/TableHeaders.utils';
import GlobalToCaps from '../../../../../../util/shared/GlobalToCaps.mixin.vue';

export default {
  name: 'ResalePropertyListDialog',
  mixins: [GlobalToCaps],
  props: {
    baseCrudKey: {
      type: String,
      default: 'ResalePropertyListDialog',
    },
    baseCrudKeyForResaleDetails: {
      type: String,
      default: 'baseCrudKeyForResaleDetails',
    },
    saleYear: {
      type: Number,
      default: null,
    },
  },
  components: {
    CRUDDialog,
    CRUDList,
    TaxFeesTableDialog,
    ClarionDateControl,
    ResalePropertDetailsList,
    AdditionalNameAddressesList,
  },
  data() {
    return {
      checkbox: true,
      baseCrudKeyAdditional: 'AdditionalNameAddressesList',
      baseCrudKeyAdditionalTable: 'AdditionalNameAddressesTableList',
      baseCrudKeyAdditionalDialog: 'AdditionalNameAddressesDialog',
      baseCrudKeyForAddDetail: 'baseCrudKeyForAddDetail',
      resaleFeesDialogCrudKey: 'resaleFeesDialog',
      resaleFeesListCrudKey: 'resaleFeesList',
      feesHeaders: FeesHeaders,
      // the detail row whose fee list is open - the fee grid has no other way of knowing which
      // tax year/tax ID it is editing, and the tax record's own _id is what keeps its totalFee
      // in sync (upsertTaxFeesHelper filters by it, not by taxYear/taxId)
      feesRowContext: { taxYear: null, taxId: null, taxInquiryTransaction: null },
      addDetail: {
        taxYear: null,
        taxId: null,
      },
    };
  },
  computed: {
    ...mapGetters('base/crud', [
      'item',
      'items',
      'criteria',
      'index',
      'isVisible',
    ]),
    ...mapState({
      taxFeeMasterData: (state) => state.shared.taxFeeMaster.taxFeeMasterData,
    }),
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKeyAdditional);
      },
      set(value) {
        this.setCriteria([this.baseCrudKeyAdditional, value]);
      },
    },
    editedItem: {
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
    feesDefaultSortBy() {
      return [
        {
          column: 'effectiveDate',
          direction: 'desc',
        },
      ];
    },
    rules() {
      return [
        (v) => {
          if (Number(v) === 0) {
            return 'Required';
          }
          return true;
        },
        (v) => !!v || 'Required.',
        () => true,
      ];
    },
  },
  methods: {
    amountFormat,
    ...mapMutations('base/crud', ['setIsVisible', 'setItem', 'setItems', 'setHighlightedId']),
    ...mapActions(['custumColrFlashMsg', 'flashSuccess']),
    ...mapActions('tax/juneResale', [
      'addDetailToJuneResaleRecords',
      'loadJuneResaleNameAndAddresses',
      'upsertJuneResaleNameAndAddresses',
      'pullCurrentDetailsToJuneResale',
      'deleteJuneResaleRowItem',
    ]),
    ...mapActions('tax/taxFee', [
      'loadTaxRollFeesTable',
      'upsertTaxFees',
      'deleteTaxFees',
    ]),
    async additionalNameAddressClick() {
      const { baseCrudKeyAdditional, baseCrudKeyAdditionalTable } = this;
      const res = await this.loadJuneResaleNameAndAddresses({
        criteria: { ...this.criteriaState, systemId: this.editedItem.systemId },
      });
      if ((res || []).length) {
        const tableList = res[0].nameAndAddressDetails.length ? res[0].nameAndAddressDetails : [];
        this.setItem([baseCrudKeyAdditional, res[0]]);
        this.setItems([baseCrudKeyAdditionalTable, tableList]);
        this.setIsVisible([this.baseCrudKeyAdditionalDialog, true]);
      } else this.custumColrFlashMsg({ msg: 'There were no records found' });
    },
    async deleteRecord(item) {
      const uptItem = item;
      if (Object.values(uptItem).length) {
        const itemList = this.item(this.baseCrudKeyAdditional);
        uptItem.zip = zipDeFormat(item.zip);
        if (uptItem._id) {
          const filterItems = (itemList.nameAndAddressDetails || [])
            .filter((ft) => ft._id !== uptItem._id);
          itemList.nameAndAddressDetails = filterItems;
        }
        itemList.saleYear = Number(this.saleYear) || null;
        await this.upsertJuneResaleNameAndAddresses({
          item: itemList,
        });
        this.flashSuccess('Record deleted successfully');
        this.setIsVisible([this.baseCrudKeyAdditionalTable, false]);
        this.additionalNameAddressClick();
      }
    },
    async upsertTransaction(item) {
      const uptItem = item;
      if (Object.values(uptItem).length) {
        const itemList = this.item(this.baseCrudKeyAdditional);
        uptItem.zip = zipDeFormat(item.zip);
        if (uptItem._id) {
          const filterItems = (itemList.nameAndAddressDetails || [])
            .filter((ft) => ft._id !== uptItem._id);
          const allItems = [...filterItems, uptItem];
          itemList.nameAndAddressDetails = allItems;
        } else {
          uptItem.isItManuallyAdded = true;
          const allItems = [...itemList.nameAndAddressDetails, uptItem];
          itemList.nameAndAddressDetails = allItems;
        }
        itemList.saleYear = Number(this.saleYear) || null;
        await this.upsertJuneResaleNameAndAddresses({
          item: itemList,
        });
        this.additionalNameAddressClick();
      }
    },
    addDetailClick() {
      this.setIsVisible([this.baseCrudKeyForAddDetail, true]);
    },
    closeAddDetailDialog() {
      this.addDetail = {
        taxYear: null,
        taxId: null,
      };
      this.setIsVisible([this.baseCrudKeyForAddDetail, false]);
    },
    handleAddNewRecord() {
      const validate = this.$refs.crudDialogForAddDetail.validateForm();
      if (!validate || !this.editedItem._id) return;
      const itemToSent = {
        _id: this.editedItem._id,
        taxYear: Number(this.addDetail.taxYear || 0),
        taxId: Number(this.addDetail.taxId || 0),
      };
      this.addDetailToJuneResaleRecords({ itemToSent }).then((res) => {
        this.closeAddDetailDialog();
        if (res.statusCode === 200) this.$emit('loadCRUDList', '', this.editedItem.systemId);
      });
    },
    pullCurrentDetailsClick() {
      const {
        _id, systemId, saleYear, saleDate, publicationDate, penaltyDate, mainTaxYear, mainTaxId,
        mainCurrentOwnerName, mainLegalDesc,
      } = this.editedItem;
      const itemToSent = {
        _id,
        systemId,
        saleYear,
        saleDate: saleDate ? toIsoDate(saleDate) : null,
        publicationDate: publicationDate ? toIsoDate(publicationDate) : null,
        penaltyDate: penaltyDate ? toIsoDate(penaltyDate) : null,
        taxYear: mainTaxYear,
        taxId: mainTaxId,
        mainCurrentOwnerName,
        mainLegalDesc,
      };
      this.pullCurrentDetailsToJuneResale({ itemToSent })
        .then(() => {
          this.$emit('loadCRUDList', '', systemId);
        });
    },
    deleteRowItem(item) {
      const retainItem = this.editedItem;

      const itemToSent = {
        _id: this.editedItem._id,
        deleteRowId: item._id,
      };
      this.deleteJuneResaleRowItem({ itemToSent }).then((res) => {
        if (res.statusCode === 200) {
          this.$emit('loadCRUDList', retainItem._id);
          this.setItem([this.baseCrudKey, retainItem]);
        }
      });
    },
    // Clicking the Total Fees amount on a detail row opens that tax year's fee list - add, edit
    // and delete - the same grid a Personal Tax Warrant detail row opens.
    async handleRowButtonClick(item) {
      this.feesRowContext = {
        taxYear: item.taxYear,
        taxId: item.taxId,
        taxInquiryTransaction: item.taxInquiryTransaction || null,
      };
      await this.loadTaxRollFeesTable({
        criteria: { taxYear: item.taxYear, taxId: item.taxId },
        baseCrudKey: this.resaleFeesListCrudKey,
        postProcessTrans: this.feesPostProcessTrans,
      });
      this.setIsVisible([this.resaleFeesDialogCrudKey, true]);
    },
    // the grid stores dates the way the Tax Inquiry fee grid does, so the edit dialog's date
    // control gets a short date and toIsoDate below turns it back on the way out
    feesPostProcessTrans(items) {
      return (items || []).map((fee) => ({
        ...fee,
        effectiveDate: fee.effectiveDate ? toShortDate(fee.effectiveDate) : fee.effectiveDate,
        paymentDate: fee.paymentDate ? toShortDate(fee.paymentDate) : fee.paymentDate,
      }));
    },
    // Pre-seeds a brand-new fee row with the tax year/tax ID it is being added under - mirrors
    // TaxRollFeesTable's handleFeeNewItem.
    createNewFeeItem() {
      return { taxYear: this.feesRowContext.taxYear, taxId: this.feesRowContext.taxId };
    },
    async upsertResaleFee(val) {
      const feeNumber = val.feeNumber ? val.feeNumber : null;
      const filteredTaxMasterList = (this.taxFeeMasterData || [])
        .filter((ft) => ft.feeNumber === feeNumber);
      const feeDescription = filteredTaxMasterList.length > 0
        ? filteredTaxMasterList[0].feeDescription : null;
      const item = {
        taxYear: this.feesRowContext.taxYear,
        taxId: this.feesRowContext.taxId,
        effectiveDate: val.effectiveDate ? toIsoDate(val.effectiveDate) : null,
        feeNumber,
        feeAmount: amountToNumber(val.feeAmount),
        feeDescription,
        taxInquiryTransaction: this.feesRowContext.taxInquiryTransaction,
      };
      if (val._id) item._id = val._id;
      const res = await this.upsertTaxFees({
        item,
        baseCrudKey: this.resaleFeesListCrudKey,
        postProcessTrans: this.feesPostProcessTrans,
      });
      if (res && res._id) await this.reloadResaleRecord();
    },
    async deleteResaleFee(item) {
      if (!window.confirm('Are you sure you want to delete this fee?')) return;
      await this.deleteTaxFees({ item, baseCrudKey: this.resaleFeesListCrudKey });
      await this.reloadResaleRecord();
    },
    // The fee save/delete recomputes this tax year's totalFeesDue and the record's rollup totals
    // server-side (syncJuneResaleDetailsForFeeChange), so the record is re-read rather than
    // patched here - and rather than rebuilt through Pull current details, which would take the
    // row's sale data with it.
    reloadResaleRecord() {
      const { _id } = this.editedItem;
      if (!_id) return null;
      return this.$emit('loadCRUDList', _id);
    },
  },
};
</script>
